import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { string } from "prop-types";

import { DefaultFooter } from "./DefaultFooter";
import BondhushavaFooter from "./BondhushavaFooter";
import { ProtichintaFooter } from "./ProtichintaFooter";
import KishoraloFooter from "./KishoraloFooter";
import { BigganChintaFooter } from "./BigganChintaFooter";
import TrustFooter from "./TrustFooter";
import { getCurrentSite } from "../../utils/utils";

const RenderFooterBase = ({ domainSlug, currentPath }) => {
  const foo = () => {
    if (domainSlug === "kishoralo" || getCurrentSite(currentPath) === "kishoralo") {
      return <KishoraloFooter />;
    } else if (domainSlug === "bondhushava" || getCurrentSite(currentPath) === "bondhushava") {
      return <BondhushavaFooter />;
    } else if (domainSlug === "protichinta" || getCurrentSite(currentPath) === "protichinta") {
      return <ProtichintaFooter />;
    } else if (domainSlug === "biggan-chinta" || getCurrentSite(currentPath) === "bigganchinta") {
      return <BigganChintaFooter />;
    } else if (domainSlug === "bigganchinta" || getCurrentSite(currentPath) === "bigganchinta") {
      return <BigganChintaFooter />;
    } else if (domainSlug === "trust" || getCurrentSite(currentPath) === "trust") {
      return <TrustFooter />;
    } else {
      return <DefaultFooter />;
    }
  };

  return <React.Fragment>{foo()}</React.Fragment>;
};

const mapStateToProps = state => ({
  currentPath: get(state, ["currentPathReducer", "currentPath"], null),
  domainSlug: get(state, ["qt", "config", "domainSlug"], null)
});

RenderFooterBase.propTypes = {
  currentPath: string,
  domainSlug: string
};

export const RenderFooter = connect(mapStateToProps, () => ({}))(RenderFooterBase);
